/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/car_2_medium'
export default icon
